window.axios = require('axios');
window.fuse = require('fuse.js');
window.Vue = require('vue');

import Search from './components/Search.vue';
import OldPost from './components/OldPost.vue';
import AnchorJS from 'anchor-js';
import Clipboard from 'clipboard';

const anchors = new AnchorJS();
anchors.options.placement = 'left';
anchors.options.icon = '#';

try {
	attachClipboard()
} catch (e) {
	console.error(e)
	console.error('failed to start clipboard');
}

anchors.add('.prose h1, .prose h2, .prose h3, .prose h4');

new Vue({
    components: {
		Search,
    },
}).$mount('#vue-search');

if (document.querySelector('#old-posts')) {
	new Vue({
		components: {
			OldPost,
		},
	}).$mount('#old-posts');
}

function attachClipboard() {

	let code = document.querySelectorAll('pre');

	if (code.length <= 0 || !Clipboard.isSupported()) {
		return;
	}

	let button = `
	<div class="clipboard-wrapper">
		<button id="clipper" data-clipboard-target="#foo" type="button">
		<svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
		</svg>
		</button>
	</div>

	`
	// `<svg width="323.057" height="323.057" xmlns="http://www.w3.org/2000/svg"><path d="M41.615 256.312c47.124 59.364 139.536 44.676 160.956-29.376 1.224-3.672 1.836-7.956 2.448-11.628-49.572-11.016-97.92-47.124-102.204-90.576-3.672-39.168 36.108-50.796 62.424-28.764 31.212 26.316 53.244 64.872 55.08 105.875 31.824 4.284 63.036-4.284 80.172-35.496 28.764-52.631-9.792-123.624-61.2-144.432-5.508-1.836-3.06-10.404 2.448-8.568 70.992 20.197 107.712 119.341 59.364 178.092-18.972 22.645-49.572 29.988-81.396 26.316-4.284 41.616-36.72 74.664-75.275 87.516-44.676 14.688-85.68-6.731-111.996-41.616-4.285-5.508 4.896-12.239 9.179-7.343zm137.088-123.624c-9.792-13.464-22.644-28.764-39.168-34.272-15.911-5.508-21.42 16.524-22.031 26.316-.612 12.24 7.956 23.256 15.912 31.824 16.523 18.971 44.063 35.496 72.215 42.839-1.836-23.868-13.464-47.123-26.928-66.707z"/><path d="M7.344 233.668c17.136 0 34.884 1.224 51.408 5.508 6.73 1.836 3.672 11.016-3.061 9.792-13.464-2.448-27.54-1.836-41.004-1.224.612 7.955 1.224 16.523 2.448 24.479 1.224 6.12 5.508 15.3 1.836 21.42-1.836 3.061-4.896 3.061-7.956 1.836-7.344-3.06-7.344-15.912-8.568-22.644C.61 261.818 0 251.415 0 240.398c0-3.67 3.672-6.73 7.344-6.73z"/></svg>`

	code.forEach(function (element, index) {
		let template = document.createElement('template');
		template.innerHTML = button;
		template = template.content.cloneNode(true);
		element.children[0].id = element.nodeName + '-' + index;
		template.querySelector('button').dataset.clipboardTarget = '#' + element.nodeName + '-' + index
		element.before(template);
	});

	let clipboard = new Clipboard("#clipper");

	clipboard.on('success', function (e) {
		let snackbar = document.querySelector('#template-snackbar');
		snackbar.innerHTML = snackbar.innerHTML.replace('{%title%}', 'Copied Successfully!')
		snackbar.innerHTML = snackbar.innerHTML.replace('{%description%}', 'Code should be on your clipboard now :)')
		document.querySelector('main').prepend(snackbar.content.cloneNode(true));
		setTimeout(() => {
			document.querySelector('#message-snack').remove();
		}, 5e3);
		// console.info('Action:', e.action);
		// console.info('Text:', e.text);
		// console.info('Trigger:', e.trigger);

		e.clearSelection();
	});

}
